import { useState } from 'react';
import { btnAccent, btnOutline, field, fieldLabelBlock } from '../lib/ui';
import { Modal } from './Modal';

/** Кавычки внутри аргумента формулы удваиваются. */
const escape = (value: string) => value.replace(/"/g, '""');

/**
 * Ссылка кладётся в ячейку не как адрес, а как формула HYPERLINK —
 * так у неё есть отдельный видимый текст.
 */
export function LinkModal({
  initialText = '', initialUrl = '', onClose, onApply,
}: {
  initialText?: string;
  initialUrl?: string;
  onClose: () => void;
  onApply: (formula: string) => void;
}) {
  const [text, setText] = useState(initialText);
  const [url, setUrl] = useState(initialUrl);

  const submit = () => {
    const address = url.trim();
    if (!address) return;
    const caption = text.trim() || address;
    onApply(`=HYPERLINK("${escape(address)}"; "${escape(caption)}")`);
    onClose();
  };

  return (
    <Modal title="Вставить ссылку" onClose={onClose} width={420}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <label style={{ ...fieldLabelBlock, marginTop: 0 }}>Текст ссылки</label>
        <input
          autoFocus
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Например: Открыть документ"
          style={field}
        />

        <label style={fieldLabelBlock}>Адрес (URL)</label>
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://…"
          style={field}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button type="button" onClick={onClose} style={btnOutline}>
            Отмена
          </button>
          <button type="submit" disabled={!url.trim()} style={btnAccent}>
            Вставить
          </button>
        </div>
      </form>
    </Modal>
  );
}
